import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TourState } from './tour.reducer';

export const selectTourState = createFeatureSelector<TourState>('tour');

export const selectTourActive = createSelector(
  selectTourState,
  (state) => state.active
);

export const selectTourCompleted = createSelector(
  selectTourState,
  (state) => state.completed
);
